import React from 'react'
import Logo from 'assets/logo/Logo.svg'
import './Header.css'
import { translation } from 'assets/translations/translations'

type Props = {
  language: string
  setLanguage: (language: string) => void
}

const Header = ({ language, setLanguage }: Props) => {
  return (
    <header className='header-main'>
      <div className='logo-container'>
        <img src={Logo} className='logo' alt='ILE Soft logo' />
        <span className='logo-name'>{translation(language, 'title')}</span>
      </div>

      <div className='header-right'>
        <div className='icons'>
          <a
            href='https://www.facebook.com/ilesoft'
            target='_blank'
            rel='noreferrer'
            className='icon-link'
            aria-label='ILE Soft Facebook'
          >
            <i className='fa-brands fa-facebook-f icon' />
          </a>

          <a
            href='https://www.instagram.com/ilesoftelectronics'
            target='_blank'
            rel='noreferrer'
            className='icon-link'
            aria-label='ILE Soft Instagram'
          >
            <i className='fa-brands fa-instagram icon' />
          </a>
        </div>

        <div className='translate'>
          <button
            type='button'
            className={`translate-btn ${
              language === 'macedonian' ? 'translate-btn-active' : ''
            }`}
            onClick={() => setLanguage('macedonian')}
          >
            MK
          </button>

          <button
            type='button'
            className={`translate-btn ${
              language === 'english' ? 'translate-btn-active' : ''
            }`}
            onClick={() => setLanguage('english')}
          >
            EN
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header